export { createFsCacheProxy } from './fsCache';